// This is just an example,
// so you can safely delete all default props below

export default {
  failed: 'Action failed',
  success: 'Action was successful',
  actions: {
    save: 'Save',
    update: 'Update',
    cancel: 'Cancel'
  },
  settings: {
    label: 'Settings',
    team: 'Team',
    details: 'Details',
    users: 'Users'
  },
  asset: {
    details: 'Details',
    create: 'New Council Property',
    edit: 'Edit Council Property',
    namePlural: 'Council Properties',
    name: 'Council Property',
    teamPlural: 'Community Groups'
  },
  team: {
    dashboard: 'Dashboard',
    details: 'Details',
    create: 'New Team',
    edit: 'Edit Team',
    namePlural: 'Team',
    name: 'Team',
    userPlural: 'Members',
    current: 'Current Team'
  },
  medicalProvider: {
    name: 'NDIS Provider',
    namePlural: 'NDIS Providers'
  },
  job: {
    name: 'Job',
    namePlural: 'Jobs'
  },
  document: {
    name: 'Document',
    namePlural: 'Documents'
  },
  address: {
    line1: 'Unit, Level, Building Name',
    line2: 'Street Number & Name',
    suburb: 'Suburb',
    state: 'State',
    postcode: 'Postcode'
  }
};